import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { ExternalLink } from "lucide-react";
import { TYPEFORM_URL } from "../constants/content";

export const openTypeform = () => {
    window.dispatchEvent(new CustomEvent("open-typeform"));
};

export const typeformLinkProps = {
    href: TYPEFORM_URL,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: (e) => {
        e.preventDefault();
        openTypeform();
    },
};

const TypeformModal = () => {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const handler = () => setOpen(true);
        window.addEventListener("open-typeform", handler);
        return () => window.removeEventListener("open-typeform", handler);
    }, []);

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent
                data-testid="typeform-modal"
                className="flex h-[86vh] w-[94vw] max-w-3xl flex-col gap-0 overflow-hidden rounded-2xl border-neon-purple/30 bg-panel p-0 glow-purple"
            >
                <DialogHeader className="flex flex-row items-center justify-between border-b border-border px-5 py-3.5">
                    <DialogTitle className="font-display text-sm font-bold tracking-widest text-white">
                        FAN<span className="text-gradient-neon">CREATOR</span> — START NOW
                    </DialogTitle>
                    <a
                        href={TYPEFORM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="typeform-modal-external-link"
                        className="mr-8 inline-flex items-center gap-1.5 font-mono-tech text-[10px] uppercase tracking-[0.2em] text-neon-blue hover:text-neon-pink"
                    >
                        Open in new tab <ExternalLink size={12} />
                    </a>
                </DialogHeader>
                <iframe
                    src={TYPEFORM_URL}
                    title="Fan Creator — Start Now"
                    data-testid="typeform-iframe"
                    className="min-h-0 w-full flex-1 bg-white"
                    allow="camera; microphone; autoplay; encrypted-media"
                />
            </DialogContent>
        </Dialog>
    );
};

export default TypeformModal;
